import { buildCameraDetectionConfigsPayload } from './detectionConfigs';

const toShiftTime = (value) => (value ? `${value}:00` : null);

/**
 * Payload для PATCH /cameras/{id} из формы админки (ТЗ №33).
 *
 * - без `id`: идентификатор камеры уже в пути запроса;
 * - detection_configs — строка, ключи детекторов из исходной камеры
 *   (детекторы меняются только через профиль детекции);
 * - RTSP отправляется, только если админ ввёл новый адрес: маскированный
 *   или прежний не уходит;
 * - локация берётся из самой камеры, чтобы сохранение не перенесло её
 *   в открытую сейчас в админке другую локацию.
 */
export const buildCameraUpdatePayload = ({ data, original, roomId, shouldIncludeRtspUrl }) => {
  const shifts = data.shifts || [];
  const payload = {
    room_id: original?.room_id ?? roomId,
    name: (data.name || '').trim(),
    frame_interval_sec: parseInt(data.frame_interval_sec, 10),
    retention_minutes: parseInt(data.retention_minutes, 10),
    slow_retry_interval_minutes: parseInt(data.slow_retry_interval_minutes, 10),
    display_timezone: data.display_timezone,
    detection_configs: buildCameraDetectionConfigsPayload(data.detection_configs || '{}', original?.detection_configs),
    type: data.type,
    owner: data.owner,
    shift1_start: toShiftTime(shifts[0]?.start),
    shift1_end: toShiftTime(shifts[0]?.end),
    shift2_start: toShiftTime(shifts[1]?.start),
    shift2_end: toShiftTime(shifts[1]?.end),
    shift3_start: toShiftTime(shifts[2]?.start),
    shift3_end: toShiftTime(shifts[2]?.end),
  };

  const rtsp = (data.rtsp_url || '').trim();
  const originalRtsp = (original?.rtsp_url || '').trim();
  if (shouldIncludeRtspUrl(rtsp) && rtsp !== originalRtsp) {
    payload.rtsp_url = rtsp;
  }

  return payload;
};
